<template>
  <div class="login-register-box">
    <plex-header></plex-header>
    <div class="text-center auto-login" v-if="autoLogging">
      <spinner :show="autoLogging"></spinner>
      <p>{{ $t('logging') }}</p>
    </div>
    <div class="login-register" v-else>
      <router-view class="login-register-content"></router-view>
    </div>
    <plex-footer></plex-footer>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../assets/scss/variables';

.login-register-box {
  width: 100%;
  min-height: 100vh;
  .auto-login {
    height: 4rem;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    p {
      margin-top: 0.2rem;
    }
  }
}
.login-register {
  min-height: 100vh;
  padding-top: 1.6rem;
  background: url('/static/img/loginRegister/bg.png') no-repeat center bottom;
}

@media (max-width: 991px) {
  .login-register {
    padding-top: 0.9rem;
  }
}

@media (max-width: 767px) {
  .login-register {
    padding: .24rem .24rem 0;
    background-image: url('/static/img/loginRegister/bg_h5.png');
    background-size: 100%;
  }
}
</style>

<script>
import Spinner from 'components/Spinner.vue';
import PlexHeader from '../../../components/plexHeader/mainHeader/Index.vue';
import PlexFooter from '../../../components/footer/Footer.vue';
import cookie from '../../../lib/cookie';
import locales from './lang';

export default {
  name: 'login-register-view',
  components: { Spinner, PlexHeader, PlexFooter },
  data: function () {
    return {
      autoLogging: false
    };
  },
  locales,
  computed: {
    redirectUrlInCookie() {
      return cookie.getCookie('redirect_url');
    },
    redirectUrl() {
      if (this.redirectUrlInCookie) {
        return this.redirectUrlInCookie;
      } else if (this.$route.query.redirect_to) {
        return '/' + this.$route.query.redirect_to;
      } else return '/dashboard';
    }
  },
  methods: {
    autoLogin() {
      if (this.$route.query.token && this.$route.query.device_id) {
        this.clientAutoLogin();
      } else if (this.$route.query.token) {
        window.localStorage.setItem('token', this.$route.query.token);
        this.$store.dispatch('getUserInformation');
        this.$router.replace(this.redirectUrl);
      } else if (window.localStorage.getItem('token') !== null && !this.$route.query['qr_token']) {
        this.$router.replace(this.redirectUrl);
      }
    },
    clientAutoLogin() {
      this.autoLogging = true;
      window.localStorage.setItem('clientToken', 'Bearer ' + this.$route.query.token);
      window.localStorage.setItem('deviceId', this.$route.query.device_id);
      this.$http.get('api/user?type=swap').then(response => {
        if (response.data.code === 0) {
          window.localStorage.setItem('token', response.body.data.access_token);
          window.localStorage.removeItem('clientToken');
          window.localStorage.removeItem('deviceId');
          this.$store.dispatch('getUserInformation');
          this.$router.replace(this.redirectUrl);
        }
      });
    },
    signOut: function () {
      this.$store.dispatch('clearUserInfo');
    }
  },
  created() {
    if (this.$route.query['qr_message']) {
      this.$toast(this.$route.query['qr_message']);
      return;
    }
    if (!this.$route.query.token && cookie.getCookie('redirect_url')) {
      cookie.removeCookie('redirect_url');
    }
    if (this.$route.query.redirect_to) {
      this.signOut();
    }
    this.autoLogin();
    this.$store.commit('setClientRedirectUrl', this.redirectUrl);
  },
};
</script>



// WEBPACK FOOTER //
// LoginRegister.vue?1b8928e1